var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#131BEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6601 11.2337C26.3531 10.9634 25.8708 10.9247 25.3722 11.1326H25.3713C24.8469 11.351 10.5265 17.7277 9.94356 17.9882C9.83753 18.0265 8.91149 18.3852 9.00688 19.1842C9.09203 19.9046 9.8363 20.2029 9.92719 20.2374L13.5679 21.5315C13.8094 22.3662 14.6998 25.4457 14.8967 26.1036C15.0196 26.5138 15.2198 27.0527 15.5706 27.1636C15.8785 27.2868 16.1847 27.1742 16.3828 27.0127L18.6087 24.8694L22.2019 27.7786L22.2874 27.8317C22.5314 27.9439 22.7652 28 22.9883 28C23.1606 28 23.326 27.9664 23.4841 27.8993C24.0224 27.6698 24.2377 27.1372 24.2603 27.0769L26.9442 12.5941C27.108 11.8206 26.8803 11.4271 26.6601 11.2337ZM16.7787 22.0491L15.5505 25.4491L14.3224 21.1991L23.7383 13.9741L16.7787 22.0491Z",
    fill: "#131BEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.020236f374ee0a89c71023331388c270.svg";
export { ForwardRef as ReactComponent };